import styled from 'styled-components'

import { Button } from '@interco/inter-ui/components/Button'
/**
 * Header com titulo do bottomsheet.
 */
export const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 8px 0px 8px;
`

/**
 * Botão
 */
export const LargeButton = styled(Button)`
  width: 100%;
`
export const SpaceBetween = styled.div`
  height: 16px;
`
